import React from "react";
import { usePageMeta } from "@/lib/usePageMeta";
import LegalLayout from "@/components/LegalLayout";

export default function LegalNotice() {
  usePageMeta({
    title: "Právní poučení | STK Komfort Znojmo",
    description:
      "Právní poučení a informace o provozovateli webu STK Komfort Znojmo. Auto concierge ve Znojmě a okolí.",
    canonical: "https://www.stkkomfort.cz/pravni-pouceni",
  });

  return (
    <LegalLayout
      title="Právní poučení"
      lead="Důležité informace o povaze služby STK Komfort™, jejích limitech a o roli třetích stran zapojených do realizace jednotlivých úkonů."
    >
      <h2>Povaha služby</h2>
      <p>
        STK Komfort™ je <strong>asistenční a zprostředkovatelská služba</strong>. Nejsme
        stanice technické kontroly ani orgán veřejné správy. Pomáháme zákazníkům se
        zajištěním STK, emisí, evidenčních kontrol, přepisů vozidel, administrativy,
        pojištění, servisu a dalších služeb spojených s vozidly.
      </p>

      <h2>STK a emise</h2>
      <p>
        STK a emise jsou zajišťovány <strong>přes partnerskou síť, zejména PSOTA Znojmo</strong>.
        Výsledek technické kontroly vždy závisí na skutečném technickém stavu vozidla
        a rozhodnutí příslušné stanice technické kontroly. STK Komfort™ negarantuje
        úspěšné absolvování STK.
      </p>
      <p>
        Pokud vozidlo technickou kontrolou neprojde, můžeme zákazníkovi doporučit další postup,
        zajistit opravu přes smluvní autoservis a případnou opakovanou kontrolu.
      </p>

      <h2>Registr vozidel a úřední úkony</h2>
      <p>
        U úkonů na registru vozidel — přepisů, převozních značek, depozitu značek, přihlášení,
        odhlášení a dalších administrativních služeb — se postup a výše správních poplatků
        řídí aktuálními právními předpisy a požadavky příslušného úřadu.
      </p>
      <p>
        STK Komfort™ neobchází ani neovlivňuje rozhodnutí úřadů. Jsme zde proto, abychom
        zákazníkovi ušetřili čas, fronty a administrativu — nikoli proto, abychom obcházeli
        platné předpisy.
      </p>

      <h2>Servisní práce a opravy</h2>
      <p>
        Servisní práce a opravy zajišťujeme přes smluvní autoservisy. Cena, rozsah a záruka
        se řídí podmínkami konkrétního servisu. STK Komfort™ vystupuje jako zprostředkovatel
        a koordinátor celého procesu.
      </p>

      <h2>Pojištění</h2>
      <p>
        Pojištění vozidel sjednáváme prostřednictvím pojišťovacích zprostředkovatelů
        a pojišťoven. Konkrétní podmínky pojištění se řídí pojistnými podmínkami příslušné
        pojišťovny.
      </p>

      <h2>Bezpečné formulace</h2>
      <p>
        V komunikaci se zákazníkem i v reklamě používáme výhradně formulace, které odpovídají
        skutečné povaze služby: &bdquo;zajištění STK&ldquo;, &bdquo;pomoc se STK&ldquo;, &bdquo;přistavení vozidla na STK&ldquo;,
        &bdquo;STK a emise přes partnerskou síť&ldquo;. <strong>Nikdy negarantujeme úspěšnou STK</strong> ani
        netvrdíme, že jsme stanice technické kontroly.
      </p>

      <p className="mt-10 text-xs text-slate-500">
        Toto právní poučení je platné od data zveřejnění. Před ostrým spuštěním webu je
        doporučena kontrola textu právníkem.
      </p>
    </LegalLayout>
  );
}
